export default "/fonts/vendor/@fontsource/fraunces/files/fraunces-all-400-normal.woff?b533ddc525c7b15c1848afe145476d29";